var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Analytics } from '../../helpers/analyticsMiddleware';
import { t } from '../../strings/i18n/i18n';
import generateUUID from 'syf-js-utilities/helpers/generateUUID';
import fileUploadConfig from '../../const/fileUploadConfig';
import ConfirmationType, { ErrorCode } from './typings';
export var deleteFile = function (uploadFiles, file) {
    return __spreadArray(__spreadArray([], uploadFiles.slice(0, uploadFiles.indexOf(file)), true), uploadFiles.slice(uploadFiles.indexOf(file) + 1), true);
};
var formatFileSize = function (bytes, decimals) {
    if (decimals === void 0) { decimals = 2; }
    if (bytes === 0)
        return "(0 Bytes)";
    var marker = 1024;
    var decimal = decimals < 0 ? 0 : decimals;
    var units = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    var size = Math.floor(Math.log(bytes) / Math.log(marker));
    return "(".concat(parseFloat((bytes / Math.pow(marker, size)).toFixed(decimal)), " ").concat(units[size], ")");
};
export var determinePrimaryButtonText = function (isSubmitted, confirmationType, errorTypes, showDeleteConfirmation, isDocumentUploaded, hasPartialUpload) {
    var data = {
        primaryText: t('button.submit'),
        primaryDataReason: ''
    };
    if (confirmationType === ConfirmationType.Delete || showDeleteConfirmation) {
        data.primaryText = "".concat(t('button.delete'));
        data.primaryDataReason = Analytics.YesDelete;
    }
    else if (confirmationType === ConfirmationType.Exit ||
        showDeleteConfirmation) {
        data.primaryText = "".concat(t('button.yesClose'));
        data.primaryDataReason = Analytics.YesClose;
    }
    else if (errorTypes.includes(ErrorCode.FileTooLarge)) {
        data.primaryDataReason = Analytics.Submit;
    }
    else if (errorTypes.includes(ErrorCode.FileInvalidType)) {
        data.primaryDataReason = Analytics.Submit;
    }
    else if (isSubmitted && isDocumentUploaded && !hasPartialUpload) {
        data.primaryText = t('button.close');
        data.primaryDataReason = Analytics.Close;
    }
    else if (isSubmitted && !isDocumentUploaded) {
        data.primaryText = t('button.close');
        data.primaryDataReason = Analytics.Fail;
    }
    else if (isSubmitted && isDocumentUploaded && hasPartialUpload) {
        data.primaryDataReason = Analytics.Fail;
    }
    else {
        data.primaryDataReason = Analytics.Submit;
    }
    return data;
};
export var determineSecondaryButtonText = function (confirmationType, errorTypes) {
    var data = {
        secondaryText: t('button.cancel'),
        secondaryDataReason: ''
    };
    if (confirmationType === ConfirmationType.Delete ||
        confirmationType === ConfirmationType.Exit) {
        data.secondaryText = t('button.goBack');
        data.secondaryDataReason = Analytics.GoBack;
    }
    else if (errorTypes.includes(ErrorCode.FileTooLarge)) {
        data.secondaryDataReason = Analytics.Cancel;
    }
    else if (errorTypes.includes(ErrorCode.FileInvalidType)) {
        data.secondaryDataReason = Analytics.Cancel;
    }
    else {
        data.secondaryDataReason = Analytics.Cancel;
    }
    return data;
};
export var calculateFileSize = function (acceptedfiles) {
    return acceptedfiles.reduce(function (accumulator, currentFile) {
        return accumulator + currentFile.size;
    }, 0);
};
export var updateErrorTypes = function (rejectedFiles, errors) {
    rejectedFiles.forEach(function (file) {
        var index = errors.findIndex(function (x) { return x === file.errors[0].code; });
        if (index === -1) {
            errors.push(file.errors[0].code);
        }
    });
    return errors;
};
export var removeErrorTypes = function (deletedFiles, errors, isAccepted, updatedFiles) {
    var maxUploadFileSize = fileUploadConfig.maxUploadFileSize;
    var errorCounts = {};
    var errorCodeofDeletedFile = 'file-too-large';
    if (isAccepted) {
        updatedFiles.forEach(function (file) {
            var errorCodeofAcceptedFile = 'file-too-large';
            if ((file === null || file === void 0 ? void 0 : file.size) > maxUploadFileSize) {
                errorCounts[errorCodeofAcceptedFile] =
                    (errorCounts[errorCodeofAcceptedFile] || 0) + 1;
            }
        });
    }
    else {
        errorCodeofDeletedFile = deletedFiles.errors[0].code;
        updatedFiles.forEach(function (file) {
            var errorCodeofRejectedFile = file.errors[0].code;
            errorCounts[errorCodeofRejectedFile] =
                (errorCounts[errorCodeofRejectedFile] || 0) + 1;
        });
    }
    var index = errors.indexOf(errorCodeofDeletedFile);
    if (!Object.prototype.hasOwnProperty.call(errorCounts, errorCodeofDeletedFile) &&
        index > -1) {
        errors.splice(index, 1);
    }
    return errors;
};
var getBase64Format = function (file) {
    return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            var encoded = reader.result.toString().replace(/^data:(.*,)?/, '');
            if (encoded.length % 4 > 0) {
                encoded += '='.repeat(4 - (encoded.length % 4));
            }
            resolve(encoded);
        };
        reader.onerror = function (error) { return reject(error); };
    });
};
export var formatUploadedDocuments = function (files) { return __awaiter(void 0, void 0, void 0, function () {
    var allPromises;
    return __generator(this, function (_a) {
        allPromises = files.map(function (file) { return __awaiter(void 0, void 0, void 0, function () {
            var name, content, fileType;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        name = file.name;
                        return [4 /*yield*/, getBase64Format(file).then(function (val) { return val; })];
                    case 1:
                        content = _a.sent();
                        fileType = name.split('.').pop();
                        return [2 /*return*/, {
                                operationId: generateUUID(),
                                content: content,
                                name: name,
                                type: fileType.toUpperCase()
                            }];
                }
            });
        }); });
        return [2 /*return*/, Promise.all(allPromises)];
    });
}); };
export default formatFileSize;
//# sourceMappingURL=helpers.js.map